'use es6';

import { postAllAvailability as postAllAvailabilityRequest } from 'MeetingsLib/api/availabilityAPI';
export var postAllAvailability = function postAllAvailability(data) {
  return function (dispatch, getState, httpClient) {
    return postAllAvailabilityRequest(httpClient, data);
  };
};